import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { ResponseMessage } from "../../common/model/ResponseMessage";
import { RouteAPI, api } from "../../common/service/apiService";
import { DisponibiliteProfessionnel } from "../../search/model/Disponibilite";
import { DisponibiliteStructure } from "../../structures/model/StructureModel";

export const getInterestProfessionnels = createAsyncThunk<any>(
    "professionnel/getInterest",
    async (_, thunkAPI) => {
        try {
            const response = await api(
                RouteAPI.DISPONIBILITE_PROFESSIONNEL_STRUCTURE_INTERESTED,
                "GET"
            );
            return (
                response.data?.map(
                    ({
                        DisponibiliteProfessionnel,
                        status,
                    }: {
                        DisponibiliteProfessionnel: DisponibiliteProfessionnel;
                        status: string;
                    }) => ({
                        ...DisponibiliteProfessionnel,
                        isInterested: { status },
                    })
                ) ?? []
            );
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error as AxiosError<ResponseMessage>
            );
        }
    }
);

export const getInterestStructure = createAsyncThunk<any>(
    "structure/getInterest",
    async (_, thunkAPI) => {
        try {
            const response = await api(
                RouteAPI.DISPONIBILITE_STRUCTURE_PROFESSIONNEL_INTERESTED,
                "GET"
            );
            return (
                response.data?.map(
                    ({
                        DisponibiliteStructure,
                        status,
                    }: {
                        DisponibiliteStructure: DisponibiliteStructure;
                        status: string;
                    }) => ({
                        ...DisponibiliteStructure,
                        isInterested: { status },
                    })
                ) ?? []
            );
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error as AxiosError<ResponseMessage>
            );
        }
    }
);

// export const getAllDisponibilities = (): ThunkAction<void, RootState, unknown, AnyAction> => {
//   return async(dispatch, getState) => {
//     dispatch(getDisponibilities());
//   }
// }
